import { render, staticRenderFns } from "./referral-fees.vue?vue&type=template&id=686e91ba"
import script from "./referral-fees.vue?vue&type=script&lang=js"
export * from "./referral-fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports